export default __webpack_public_path__ + "static/media/strips_subscription_guide.08066c19.webp";